export default function getCurrencyFractionDigits(rate: number) {
  if (rate <= 0) {
    throw new Error('Exchange rate must be a positive number');
  }
  const log10 = Math.log10(rate);
  if (Math.ceil(log10) === 2) {
    return 2;
  }
  if (log10 > 0) {
    return 0;
  }
  const decimalPlaces = Math.ceil(Math.abs(log10));
  return Math.max(decimalPlaces, 2);
}
